import { useState, useEffect, useCallback } from "react";
import { api } from "../lib/api";

// Feature requests. Note the page number is a path segment, not a query parameter.
export function useFeatureRequests() {
  const [requests, setRequests] = useState([]);
  const [page, setPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);
  const [filters, setFilters] = useState({ search: "", status: "", category: "", sort: "most_votes" });
  const [statusCounts, setStatusCounts] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const qs = new URLSearchParams(
        Object.entries(filters).filter(([, v]) => v)
      ).toString();
      const data = await api.get(`s1/api/requests/${page}${qs ? `?${qs}` : ""}`);
      setRequests(data?.results || []);
      setTotalPages(data?.pagination?.totalPages || 1);
      setStatusCounts(data?.statusCounts || {});
      setError("");
    } catch (e) {
      setError(e.message || "Could not load feature requests.");
    } finally { setLoading(false); }
  }, [page, filters]);

  useEffect(() => { load(); }, [load]);

  const vote = useCallback(async (id, voteType) => {
    // Optimistic: the count is the only thing that changes and a refetch would reorder
    // the list under the cursor mid-click.
    setRequests((prev) => prev.map((r) => r.id === id ? { ...r, votes: (r.votes || 0) + (voteType === "up" ? 1 : -1) } : r));
    try { await api.post(`s1/api/requests/${id}/vote`, { voteType }); }
    catch { load(); }
  }, [load]);

  const create = useCallback(async (payload) => {
    await api.post("s1/api/requests", payload);
    setPage(1);
    await load();
  }, [load]);

  return { requests, loading, error, page, setPage, totalPages, statusCounts, filters, setFilters, vote, create };
}
